/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const goodLuckCoreEntitiesWinnerPromotionModeSchema = z.enum([
  "Manual",
  "Discord",
  "RiotApi",
  "Desktop",
  "Replay",
]);
